import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import uuid from "react-uuid";
import Loading from "../../../common/components/loading/loading";
import { getTerms } from "../../../common/services/markets/termService";
import SearchBox from "../../../common/components/search/searchBox";
import TermsTable from "./termsTable";
import { withTranslation } from "react-i18next";

class Terms extends Component {
  constructor(props) {
    super(props);

    this.handleTermUpdated = this.handleTermUpdated.bind(this);
  }

  state = {
    terms: [],
    searchQuery: "",
    activeOnly: true,
    sortColumn: { path: "name", order: "asc" },
    isLoading: true,
  };

  async componentDidMount() {
    this.setState({ terms: await getTerms(), isLoading: false });
  }

  handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  handleSort = (event) => {
    const { api } = event;
    const columnState = api.getColumnState();
    const sortedColumn = columnState.find((col) => col.sort);

    if (sortedColumn) {
      this.setState({
        sortColumn: {
          path: sortedColumn.colId,
          order: sortedColumn.sort,
        },
      });
    }
  };

  handleToggleActiveOnly = () => {
    this.setState({ activeOnly: !this.state.activeOnly });
  };

  handleTermSelected = (term, isNew = false) => {
    //Inject the callback function before calling back to the onClick event.
    this.props.onClick(term, this.handleTermUpdated, isNew);
  };

  handleTermUpdated = (term) => {
    const terms = [...this.state.terms];
    const index = terms.findIndex((u) => u.termId === term.termId);
    if (index > -1) {
      terms.splice(index, 1);
    }
    terms.push(term);
    this.setState({ terms: terms });
  };

  getFilteredData = () => {
    const { sortColumn, searchQuery, terms: allTerms, activeOnly } = this.state;

    let filtered = allTerms;

    if (activeOnly) filtered = filtered.filter((u) => u.active);

    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          (u.name != null &&
            u.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (u.termScheduleName != null &&
            u.termScheduleName
              .toLowerCase()
              .includes(searchQuery.toLowerCase()))
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    return sorted;
  };

  render() {
    const { searchQuery, sortColumn, activeOnly, isLoading } = this.state;

    if (isLoading) return <Loading />;

    const { t, allowEdit } = this.props;

    const terms = this.getFilteredData();

    const newTerm = {
      termId: uuid(),
      name: t("NewTerm"),
    };

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
          </div>
          <div className="col">
            <Form.Switch
              className="switch"
              type="switch"
              label={t("ActiveOnly")}
              checked={activeOnly}
              value={activeOnly}
              onChange={this.handleToggleActiveOnly}
            />
          </div>
          <div className="col">
            {allowEdit && (
              <button
                onClick={() => this.handleTermSelected(newTerm, true)}
                className="btn btn-sm btn-primary float-sm-right"
              >
                {t("AddTerm")}
              </button>
            )}
          </div>
        </div>
        <p>{t("RetrievedTerm", { count: terms.length })}</p>
        <TermsTable
          terms={terms}
          sortColumn={sortColumn}
          onSort={this.handleSort}
          onRowClick={this.handleTermSelected}
        />
      </div>
    );
  }
}

export default withTranslation(["markets"])(Terms);
